"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var MuiInputLabel = function MuiInputLabel() {
  return {
    outlined: {
      transform: 'translate(24px, 16px) scale(1)',
      '&$marginDense': {
        transform: 'translate(24px, 8px) scale(1)'
      },
      '&$shrink': {
        transform: 'translate(24px, 6px) scale(0.75)',
        '&$marginDense': {
          transform: 'translate(24px, -6px) scale(0.75)'
        }
      }
    }
  };
};

var _default = MuiInputLabel;
exports["default"] = _default;